import API from "../../services/api";
import { normalizeApiError } from "../../utils/normalizeApiError";

export const CONTACT_SUBJECTS = [
  "Account and login assistance",
  "HRMS and payroll software support",
  "Employee and company setup",
  "Subscription and plan-related queries",
  "Billing and payment issues",
  "Subscription cancellation",
  "Refund request",
  "Technical issues",
  "Product and feature-related questions",
  "Business enquiry",
  "Privacy-related enquiry",
  "Other",
];

export async function submitContactEnquiry(payload) {
  try {
    const { data } = await API.post("/contact/enquiry", payload);
    return data;
  } catch (err) {
    throw new Error(normalizeApiError(err));
  }
}
